import usePopup from '@/root/hooks/usePopup';

import Popup from '@/shared/components/Popup/Layout';
import {TIARA_ACTION} from '@/shared/constants/tiara';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';

const CardDeleteFailPopup = () => {
  const {closePopup} = usePopup();

  useHistoryBackAOS(closePopup);

  return (
    <Popup>
      <Popup.Title>카드가 삭제되지 않았습니다</Popup.Title>
      <Popup.Content>
        예상하지 못한 오류가 발생했습니다.
        <br />
        서버의 일시적인 장애이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해 주세요.
      </Popup.Content>
      <Popup.GroupButton>
        <button
          type="button"
          className="btn btn_gray"
          data-tiara-action-name={TIARA_ACTION.CONFIRM_CLICK}
          onClick={closePopup}
        >
          확인
        </button>
      </Popup.GroupButton>
    </Popup>
  );
};

export default CardDeleteFailPopup;
